"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsFocusedNotPage = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var debounce_1 = require("../../utils/debounce");
var useIsFocusedNotPage = function () {
    var _a = React.useState(false), pageNotFocused = _a[0], setPageNotFocused = _a[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var setFocusedDebounced = React.useCallback((0, debounce_1.debounce)(function (hidden) { return setPageNotFocused(hidden); }, 1000), []);
    var changeVisability = function () {
        switch (document.visibilityState) {
            case 'hidden':
                setFocusedDebounced(true);
                break;
            case 'visible':
                setFocusedDebounced(false);
                break;
        }
    };
    React.useEffect(function () {
        document.addEventListener('visibilitychange', changeVisability);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return pageNotFocused;
};
exports.useIsFocusedNotPage = useIsFocusedNotPage;
//# sourceMappingURL=index.js.map